const { includes } = require('lodash');

/**
 * Converts Source string to aisle primary and secondary categories
 *
 * @param {String} Source The Source of the item in the form of Woolworths.Desktop.LF.Aisle.[PrimaryCategory].[SubCategory] or Woolworths.Desktop.LF.ProductDetail
 * @returns {Object} object containing primaryCategory and subCategory
 */
function getCategories(source) {
    const categories = { primaryCategory: undefined, subCategory: undefined };
    if (typeof source !== 'string') return categories;

    if (includes(source, 'Aisle.')) {
        const aislePrimarySub = source.substring(source.indexOf('Aisle')).split('.'); // [Aisle, FruitVeg, OrganicFreshFruitVeg]
        categories.primaryCategory = aislePrimarySub[1];
        categories.subCategory = aislePrimarySub[2];
    } else if (includes(source, '.ProductDetail')) {
        categories.primaryCategory = 'ProductDetail';
        categories.subCategory = 'ProductDetail';
    }

    return categories;
}

module.exports = getCategories;



// WEBPACK FOOTER //
// ./src/olycommon/analytics/dtm/helpers/product-categories.js